var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.51073e-07 6C7.51073e-07 9.3138 2.6862 12 6 12C9.3138 12 12 9.3138 12 6C12 2.6862 9.3138 0 6 0V1.2C7.14928 1.20013 8.26037 1.61262 9.13131 2.36249C10.0022 3.11236 10.5752 4.14984 10.7461 5.28635C10.917 6.42285 10.6744 7.58295 10.0625 8.55577C9.45053 9.52859 8.50985 10.2496 7.41142 10.5876C6.31299 10.9257 5.12972 10.8584 4.07667 10.3981C3.02363 9.93768 2.17072 9.11475 1.67298 8.07885C1.17523 7.04295 1.06569 5.86284 1.36426 4.75302C1.66283 3.6432 2.34969 2.67734 3.3 2.031V3.6H4.5V0H0.900001V1.2H2.4C1.65448 1.75856 1.04941 2.4832 0.632803 3.3164C0.2162 4.14961 -0.00046555 5.06845 7.51073e-07 6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReorder);
export default __webpack_public_path__ + "static/media/Reorder.3f71b974ccaf9cd0e4535f7b18860b68.svg";
export { ForwardRef as ReactComponent };